<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 员工表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="formData.id !== '0' && formData.id !== ''">
        <el-button v-if="formStatus" type="info" size="mini" round icon="em-icon-save" @click="handlerEdit"> 取消编辑</el-button>
        <el-button v-else type="primary" size="mini" round icon="em-icon-save" @click="handlerEdit"> 编辑信息</el-button>
      </template>
      <el-button v-if="formStatus && (formData.creater_id === operator_id || editable === '是')" type="primary" size="mini" plain round icon="em-icon-save" @click="saveHandler"> 提交保存</el-button>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="90px">
        <!-- 员工信息 开始-->
        <el-row :gutter="20">
          <el-col :span="4" style="position: relative;">
            <div style="width: 100%; height: 358px;">
              <el-upload class="picture-uploader" :action="this.$apis.uploadImage" :show-file-list="false" :on-success="handleImageSuccess" :before-upload="beforeImageUpload">
                <img v-if="formData.photo" :src="this.$apiroot + formData.photo" class="picture">
                <template v-else>
                  <i class="el-icon-upload picture-uploader-icon"></i>
                  <span>照片上传</span>
                </template>
              </el-upload>
            </div>
          </el-col>
          <el-col :span="11">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名" :rules="[{required: true}]">
                  <el-input v-if="formStatus" placeholder="姓名" clearable v-model="formData.name"></el-input>
                  <span v-else>{{formData.name}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="员工号">
                  <el-input v-if="formStatus" placeholder="员工号" clearable v-model="formData.code"></el-input>
                  <span v-else>{{formData.code}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="职务">
                  <el-select v-if="formStatus" size="mini" v-model="formData.position_id" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in positions" :key="item.id" :label="item.dict_value" :value="item.id"></el-option>
                  </el-select>
                  <span v-else>{{formData.position_title}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别">
                  <el-select v-if="formStatus" size="mini" v-model="formData.sex" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in sexes" :key="item.label" :label="item.label" :value="item.label"></el-option>
                  </el-select>
                  <span v-else>{{formData.sex}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="身份证号">
                  <el-input v-if="formStatus" placeholder="身份证号" v-model="formData.card_no"></el-input>
                  <span v-else>{{formData.card_no}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生日">
                  <el-date-picker v-if="formStatus" v-model="formData.birthday" type="date" placeholder="生日" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                  <span v-else>{{formData.birthday}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="年龄">
                  <el-input v-if="formStatus" placeholder="年龄" v-model="formData.age"></el-input>
                  <span v-else>{{formData.age}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="学历">
                  <el-select v-if="formStatus" size="mini" v-model="formData.data_dictionary_id" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in educations" :key="item.id" :label="item.dict_value" :value="item.id"></el-option>
                  </el-select>
                  <span v-else>{{formData.dict_value}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="电话">
                  <el-input v-if="formStatus" placeholder="电话" v-model="formData.phone"></el-input>
                  <span v-else>{{formData.phone}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="微信号">
                  <el-input v-if="formStatus" placeholder="微信号" v-model="formData.wechat_no"></el-input>
                  <span v-else>{{formData.wechat_no}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="电子邮箱">
                  <el-input v-if="formStatus" placeholder="电子邮箱" v-model="formData.email"></el-input>
                  <span v-else>{{formData.email}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否兼职">
                  <el-select v-if="formStatus" size="mini" v-model="formData.is_part_timer" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in yesOrNo" :key="item.label" :label="item.label" :value="item.label"></el-option>
                  </el-select>
                  <span v-else>{{formData.is_part_timer}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="入职时间">
                  <el-date-picker v-if="formStatus" v-model="formData.entry_time" type="date" placeholder="入职时间" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                  <span v-else>{{formData.entry_time}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="离职时间">
                  <el-date-picker v-if="formStatus" v-model="formData.resignation_time" type="date" placeholder="离职时间" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                  <span v-else>{{formData.resignation_time}}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                  <span v-else>{{formData.remark}}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="9">
            <div style="width: 100%; height: 358px; position: relative;">
              <div class="detail-header">
                <div class="detail-title"><i class="em-icon-th-list"></i> 员工附件信息</div>
                <el-button-group v-if="formStatus">
                  <el-upload class="upload-controller" :action="this.$apis.uploadFiles" multiple :show-file-list='false' :on-success="fileUploadSuccess">
                    <el-button type="primary" size="mini" icon="el-icon-upload" style="float: left;"> 点击上传附件</el-button>
                  </el-upload>
                </el-button-group>
              </div>
              <div class="el-table-container form-details" style="top: 29px; right: 0px; bottom: 0px; left: 0px;">
                <!--编辑时附件从表数据 开始-->
                <div style="height: 100%;">
                  <el-table :data="formData.files" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row">
                    <el-table-column label="操作" width="49" align="center">
                      <template v-slot:default="item">
                        <el-button v-if="formStatus" icon="el-icon-close" size="mini" circle type="danger" @click="handlerDelFile(item.row, item.$index)"></el-button>
                        <span v-else>--</span>
                      </template>
                    </el-table-column>
                    <el-table-column type="index" label="序号" width="49" align="center"></el-table-column>
                    <el-table-column label="文件名称" width="220" align="center">
                      <template v-slot:default="item">
                        <el-input v-if="formStatus" size="mini" v-model="item.row.file_name" clearable></el-input>
                        <span v-else>{{item.row.file_name}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="文件类型" prop="file_type" width="80" align="center"></el-table-column>
                    <el-table-column label="排序" width="49" align="center">
                      <template v-slot:default="item">
                        <el-input v-if="formStatus" size="mini" v-model="item.row.sort"></el-input>
                        <span v-else>{{item.row.sort}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="备注" align="center">
                      <template v-slot:default="item">
                        <el-input v-if="formStatus" size="mini" v-model="item.row.remark"></el-input>
                        <span v-else>{{item.row.remark}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="下载" width="49" align="center">
                      <template v-slot:default="item">
                        <el-button type="success" size="mini" icon="el-icon-download" circle @click="downLoadFile(item.row.file_url)"></el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="form-footer">
        <span>制单人：{{formData.creater_name}}</span>
        <span>制单日期：{{formData.create_time}}</span>
      </div>
    </div>
  </el-dialog>
</template>
<style>
  .picture-uploader {
    width: 100%;
    height: 100%;
  }
  .picture-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  .picture-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .picture-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    margin-top: 48%;
    text-align: center;
    box-sizing: border-box;
  }
  .picture {
    margin: 0 auto;
    height: 100%;
    display: block;
  }
</style>
<script>
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      // 主表单数据结构
      formEmptyData: {
        id: '',
        name: '',
        code: '',
        position_id: '',
        // 系统中数据字典外键，记录的是“学历”
        data_dictionary_id: '',
        // 性别
        sex: '男',
        // 身份证号
        card_no: '',
        // 照片
        photo: '',
        // 年龄
        age: '',
        // 生日
        birthday: '',
        // 电话
        phone: '',
        // 微信号
        wechat_no: '',
        // 电子邮件
        email: '',
        // 入职时间
        entry_time: '',
        // 离职时间
        resignation_time: '',
        // 是否兼职
        is_part_timer: '否',
        // 备注
        remark: '',
        creater_id: '',
        creater_name: sessionStorage.getItem('operator'),
        create_time: '',
        updater_id: '',
        // 员工文档
        files: []
      },
      // 性别
      sexes: [
        { label: '男' },
        { label: '女' }
      ],
      // 是否
      yesOrNo: [
        { label: '是' },
        { label: '否' }
      ],
      fileEmptyData: {
        id: '',
        employee_id: '',
        raw_file_name: '',
        file_name: '',
        file_type: '',
        file_url: '',
        file_size: '',
        sort: '',
        remark: '',
        creater_id: ''
      },
      // 学历
      educations: [],
      // 表单编辑状态
      formStatus: false,
      positions: [],
      editable: this.$store.state.editable,
      operator_id: sessionStorage.getItem('operator_id')
    }
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getEmployee, { ModelId: _this.formData.id }, function (res) {
        let _json = res.data
        let _formData = _json.employee
        if (_formData != null) {
          _this.formData = _formData
        } else {
          _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
          _this.formData.creater_id = _this.operator_id
        }
        _this.positions = _json.positions
        _this.educations = _json.educations
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    addHandler: function () {
      this.formData.id = '0'
      this.formStatus = true
      this.loadData()
      this.isShow = true
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.formStatus = false
      this.loadData()
      this.isShow = true
    },
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.name === '') {
          _this.$message({
            type: 'error',
            message: '员工姓名不能为空'
          })
          return false
        }
      }
      return true
    },
    handlerEdit: function () {
      this.formStatus = !this.formStatus
    },
    handlerDelFile: function (_row, _index) {
      let _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 如果当前行的id为空，说明仅仅是上传，尚未保存至数据库，因此，不需要提交到后台判断，仅仅从数组中删除即可
        if (_row.id === '') {
          _this.post(_this.$apis.delFiles, { fileUrl: _row.file_url }, function (res) {
            let _json = res.data
            if (_json.status === 'ok') {
              _this.formData.files.splice(_index, 1)
              _this.$message({
                message: '操作成功',
                type: 'success'
              })
            } else {
              _this.$message({
                message: '操作失败',
                type: 'success'
              })
            }
          })
          _this.formData.files.splice(_index, 1)
        } else {
          // ajax提交至服务器，删除数据
          _this.post(_this.$apis.delEmployeeFiles, { ids: _row.id, operator_id: _this.operator_id }, function (res) {
            let _json = res.data
            if (_json.status === 'ok') {
              _this.formData.files.splice(_index, 1)
              _this.$message({
                message: '操作成功',
                type: 'success'
              })
            } else {
              _this.$message({
                message: '操作失败',
                type: 'success'
              })
            }
          })
        }
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 保存
    saveHandler: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveEmployee, _this.formData, function (res) {
          let _json = res.data
          if (_json.status === 'ok') {
            _this.$message({
              message: '保存成功',
              type: 'success'
            })
            _this.parent.loadData()
            _this.isShow = false
            _this.formStatus = false
          }
        })
      }
    },

    /* 上传相关 */
    handleImageSuccess: function (res, file) {
      this.formData.photo = res.url
    },
    beforeImageUpload: function (file) {
      const isIMG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isIMG) {
        this.$message.error('上传照片的格式只能是jpg，png，gif')
      }
      if (!isLt2M) {
        this.$message.error('上传照片的大小不能超过 2MB!')
      }
      return isIMG && isLt2M
    },

    fileUploadSuccess: function (res) {
      let _this = this
      let _status = res.status
      if (_status === 'ok') {
        let _fileInfo = res.fileInfo
        if (_fileInfo !== null) {
          let _newFile = JSON.parse(JSON.stringify(this.fileEmptyData))
          _newFile.raw_file_name = _fileInfo.raw_file_name
          _newFile.file_name = _fileInfo.file_name
          _newFile.file_url = _fileInfo.file_url
          _newFile.file_type = _fileInfo.file_type
          _newFile.file_size = _fileInfo.file_size
          _newFile.sort = _this.formData.files.length + 1
          _this.formData.files.push(_newFile)
        }
      }
    },
    // 下载文件
    downLoadFile: function (_fileUrl) {
      window.open(this.$apiroot + _fileUrl)
    }
  },
  components: {
  }
}
</script>
